import {
  CompoundSearchResult,
  NewCompoundSearchResult,
  PropertySearchResult,
  SearchResultsResponse
} from '../dtos';

export type SearchResult =
  | NewCompoundSearchResult
  // | CompoundSearchResult
  | PropertySearchResult;
export type SearchResults = SearchResult[] | null;

export const enum NewCompoundSearchFiltersTypes {
  compounds = 'compoundsIds',
  hasGarden = 'hasGarden',
  hasRoof = 'hasRoof',
  maxUnitArea = 'maxUnitArea',
  minUnitArea = 'minUnitArea',
  isNawyNow = 'isNawyNow',
  minPrice = 'minPrice',
  maxPrice = 'maxPrice',
  maxDownPayment = 'maxDownPayment',
  maxInstallments = 'maxInstallments',
  areas = 'areaIds',
  developers = 'developerIds',
  propertyTypes = 'propertyTypeIds',
  amenities = 'propertyAmenityIds',
  bedrooms = 'numberOfBedrooms',
  bathrooms = 'numberOfBathrooms',
  saleType = 'resaleType',
  finishing = 'finishing',
  installmentYears = 'installmentYears',
  isDelivered = 'isDelivered',
  readyByYears = 'readyBy',
  minReadyBy = 'minReadyBy',
  orderBy = 'orderBy'
}

export interface NewSearchFilters {
  compoundsIds?: number[];
  hasGarden?: boolean;
  hasRoof?: boolean;
  maxUnitArea?: number;
  minUnitArea?: number;
  isNawyNow?: boolean;
  minPrice?: number;
  maxPrice?: number;
  maxDownPayment?: number;
  maxInstallments?: number;
  areaIds?: number[];
  developerIds?: number[];
  propertyTypeIds?: number[];
  propertyAmenityIds?: [number];
  numberOfBedrooms?: number[];
  numberOfBathrooms?: number[];
  resaleType?: string[];
  finishing?: string[];
  installmentYears?: number[];
  isDelivered?: boolean;
  readyBy?: number;
  minReadyBy?: number;
}

export interface SearchBodyInterface {
  isFetching: boolean;
  isError: boolean;
  loadedSearchResults: SearchResults;
  loadedSearchResultsCount: number;
  loadedPropertyTypes: [{ id: number; count: number }];
  loadedAmenities: [{ id: number; count: number }];
  firstRenderSSR: boolean;
  ssrSearchType: 'properties' | 'compounds';
  isLoading: boolean;
}
export interface SearchResultsProps {
  customized?: boolean;
}
